export const health: [number, number][] = [
  [5.39108295074379, 4.641151483166855],
  [6.191082187804337, 6.041153009045761],
  [4.091083713683243, 12.841152246106308],
  [5.69108409515297, 5.741151864636581],
  [6.49108523956215, 9.041153009045761],
  [7.39108295074379, 6.641151483166855],
  [5.2910844766226965, 3.2411518646365813],
  [4.091083713683243, 8.241151864636581],
  [2.3910829507437903, 0.24115186463658134],
  [4.19108409515297, 9.841152246106308],
  [7.091083713683243, 7.241151864636581],
  [3.69108409515297, 6.4411526275760345],
  [1.5910837136832434, 2.9411526275760345],
  [5.7910844766226965, 3.841152246106308],
  [6.691082187804337, 3.1411514831668548],
  [5.991083332213517, 1.4411526275760345],
  [4.591083713683243, 3.341152246106308],
  [3.7910844766226965, 5.341152246106308],
  [5.19108409515297, 8.841152246106308],
  [5.19108409515297, 4.041153009045761],
  [4.7910844766226965, 5.9411526275760345],
  [6.7910844766226965, 6.641151483166855],
  [3.5910837136832434, 0.041153009045761024],
  [5.7910844766226965, 5.141151483166855],
  [5.091083713683243, 0.24115186463658134],
  [7.7910844766226965, 6.141151483166855],
  [6.7910844766226965, 9.641151483166855],
  [5.991083332213517, 3.1411514831668548],
  [4.491083332213517, 6.9411526275760345],
  [4.19108409515297, 8.941152627576034],
  [7.89108295074379, 6.841152246106308],
  [5.89108295074379, 10.841152246106308],
  [6.591083713683243, 8.441152627576034],
  [4.491083332213517, 4.541153009045761],
  [4.19108409515297, 2.841152246106308],
  [3.0910837136832434, 3.1411514831668548],
  [6.99108523956215, 7.841152246106308],
  [5.39108295074379, 8.241151864636581],
  [3.3910829507437903, 5.841152246106308],
  [2.2910844766226965, 2.9411526275760345],
  [3.7910844766226965, 3.4411526275760345],
  [3.0910837136832434, 4.641151483166855],
  [5.19108409515297, 5.541153009045761],
  [2.8910829507437903, 2.341152246106308],
  [5.991083332213517, 8.341152246106308],
  [7.2910844766226965, 8.441152627576034],
  [4.091083713683243, 5.9411526275760345],
  [3.0910837136832434, 5.241151864636581],
  [4.491083332213517, 3.9411526275760345],
  [6.191082187804337, 2.4411526275760345],
  [6.39108295074379, 3.841152246106308],
  [2.5910837136832434, 4.341152246106308],
  [5.39108295074379, 10.441152627576034],
  [3.69108409515297, 13.441152627576034],
  [6.591083713683243, 1.9411526275760345],
  [6.99108523956215, 3.841152246106308],
  [4.2910844766226965, 6.4411526275760345],
  [7.091083713683243, 9.041153009045761],
  [4.69108409515297, 8.141151483166855],
  [7.2910844766226965, 3.341152246106308],
  [3.19108409515297, 0.8411522461063079],
  [6.99108523956215, 2.6411514831668548],
  [2.991083332213517, -0.458846990954239],
  [5.69108409515297, 6.741151864636581],
  [7.591083713683243, 4.541153009045761],
  [6.2910844766226965, 6.541153009045761],
  [4.39108295074379, 5.341152246106308],
  [6.7910844766226965, 5.9411526275760345],
  [0.8910829507437903, 2.2411518646365813],
  [6.2910844766226965, 7.141151483166855],
  [7.591083713683243, 8.041153009045761],
  [6.99108523956215, 5.4411526275760345],
  [4.89108295074379, 5.041153009045761],
  [3.8910829507437903, 6.9411526275760345],
  [1.3910829507437903, 1.4411526275760345],
  [7.2910844766226965, 5.9411526275760345],
  [4.69108409515297, 1.2411518646365813],
  [1.9910833322135169, 0.9411526275760345],
  [4.39108295074379, -0.3588485168331452],
  [6.2910844766226965, 10.341152246106308],
  [4.19108409515297, 0.6411514831668548],
  [7.691082187804337, 7.4411526275760345],
  [6.39108295074379, 7.741151864636581],
  [5.89108295074379, 7.741151864636581],
  [6.2910844766226965, 5.4411526275760345],
  [3.5910837136832434, 1.541153009045761],
  [7.7910844766226965, 5.541153009045761],
  [5.491083332213517, 6.241151864636581],
  [4.991083332213517, 6.4411526275760345],
  [3.8910829507437903, 4.741151864636581],
  [4.19108409515297, 11.341152246106308],
  [7.091083713683243, 4.841152246106308],
  [4.89108295074379, 2.541153009045761],
  [5.591083713683243, 7.241151864636581],
  [4.2910844766226965, 1.9411526275760345],
  [4.89108295074379, 11.741151864636581],
  [4.991083332213517, 7.041153009045761],
  [5.591083713683243, 0.9411526275760345],
  [5.591083713683243, 2.541153009045761],
  [4.491083332213517, 7.541153009045761],
  [6.49108523956215, 5.041153009045761],
  [4.7910844766226965, 10.241151864636581],
  [2.69108409515297, 1.6411514831668548],
  [2.2910844766226965, 3.6411514831668548],
  [5.491083332213517, 11.441152627576034],
  [3.991083332213517, 7.541153009045761],
  [5.991083332213517, 4.541153009045761],
  [3.0910837136832434, 3.841152246106308],
  [3.5910837136832434, 2.4411526275760345],
  [5.89108295074379, 9.041153009045761],
  [7.591083713683243, 5.041153009045761],
  [6.691082187804337, 4.4411526275760345],
  [5.091083713683243, 7.641151483166855],
  [3.69108409515297, -0.958846990954239],
  [4.591083713683243, 8.741151864636581],
  [3.7910844766226965, 4.141151483166855],
  [4.091083713683243, 12.041152055371445],
  [6.091083713683243, 9.841152246106308],
  [1.8910829507437903, 2.1411514831668548],
  [5.491083332213517, 9.441152627576034],
  [5.2910844766226965, 1.841152246106308],
  [7.49108523956215, 4.041153009045761],
  [4.69108409515297, 9.441152627576034],
  [4.2910844766226965, 10.641151483166855],
  [5.19108409515297, 9.841152246106308],
  [4.89108295074379, 11.041153009045761],
  [4.69108409515297, 12.341152246106308],
  [-7.2089155233773035, -7.258846228014786],
  [-7.508916667786483, -5.058849279772598],
  [-6.008916667786483, -10.158847753893692],
  [-10.20891647705162, -9.058849279772598],
  [-5.008916667786483, -7.858848516833145],
  [-5.508916667786483, -9.858848516833145],
  [-9.10891704925621, -8.358848516833145],
  [-8.508916667786483, -6.158847753893692],
  [-5.10891704925621, -6.258846228014786],
  [-9.708915523377303, -9.458846990954239],
  [-8.60891704925621, -9.458846990954239],
  [-6.508916667786483, -10.558849279772598],
  [-6.2089155233773035, -11.058849279772598],
  [-7.10891704925621, -8.058849279772598],
  [-7.10891704925621, -8.658847753893692],
  [-4.60891704925621, -9.458846990954239],
  [-4.7089155233773035, -7.158847753893692],
  [-6.508916667786483, -3.8588485168331452],
  [-8.208915523377303, -7.358848516833145],
  [-4.80891590484703, -3.5588473724239655],
  [-8.008916667786483, -5.458846990954239],
  [-7.60891704925621, -8.958846990954239],
  [-6.80891590484703, -9.958846990954239],
  [-5.30891590484703, -9.258846228014786],
  [-4.2089155233773035, -5.458846990954239],
  [-8.80891590484703, -7.358848516833145],
  [-5.60891704925621, -8.558849279772598],
  [-6.008916667786483, -4.358848516833145],
  [-4.30891590484703, -8.058849279772598],
  [-7.008916667786483, -10.658847753893692],
  [-4.508916667786483, -6.258846228014786],
  [-8.408916286316757, -8.458846990954239],
  [-6.2089155233773035, -9.658847753893692],
  [-8.408916286316757, -9.958846990954239],
  [-9.008916667786483, -9.758846228014786],
  [-9.408916286316757, -7.458846990954239],
  [-5.80891590484703, -6.558849279772598],
  [-5.10891704925621, -4.358848516833145],
  [-6.60891704925621, -7.458846990954239],
  [-4.908916286316757, -5.258846228014786],
  [-7.7089155233773035, -7.758846228014786],
  [-3.6089170492562097, -6.058849279772598],
  [-7.2089155233773035, -6.458846990954239],
  [-5.60891704925621, -7.858848516833145],
  [-9.60891704925621, -8.658847753893692],
  [-6.7089155233773035, -9.158847753893692],
  [-3.4089162863167566, -5.058849279772598],
  [-9.80891590484703, -8.058849279772598],
  [-6.508916667786483, -6.158847753893692],
  [-5.508916667786483, -7.158847753893692],
  [-6.008916667786483, -9.058849279772598],
  [-7.2089155233773035, -9.458846990954239],
  [-10.608916095581893, -8.858848516833145],
  [-3.2089155233773035, -6.858848516833145],
  [-6.408916286316757, -8.458846990954239],
  [-8.30891590484703, -6.758846228014786],
  [-5.7089155233773035, -5.058849279772598],
  [-7.7089155233773035, -6.858848516833145],
  [-5.908916286316757, -3.458846990954239],
  [-8.508916667786483, -7.958846990954239],
  [-7.408916286316757, -10.158847753893692],
  [-7.80891590484703, -9.558849279772598],
  [-7.30891590484703, -5.758846228014786],
  [-6.30891590484703, -7.858848516833145],
  [-5.7089155233773035, -5.758846228014786],
  [-2.6089170492562097, -5.858848516833145],
  [-8.208915523377303, -9.058849279772598],
  [-6.60891704925621, -5.558849279772598],
  [-7.908916286316757, -6.158847753893692],
  [-10.20891647705162, -8.458846990954239],
  [-4.80891590484703, -10.058849279772598],
  [-4.908916286316757, -8.658847753893692],
  [-5.60891704925621, -10.558849279772598],
  [-6.508916667786483, -6.858848516833145],
  [-3.7089155233773035, -7.658847753893692],
  [-8.908916286316757, -8.858848516833145],
  [-4.2089155233773035, -4.358848516833145],
  [-4.2089155233773035, -8.758846228014786],
  [-5.008916667786483, -10.758846228014786],
  [-5.7089155233773035, -11.258846228014786],
  [-9.208915523377303, -7.858848516833145],
  [-7.908916286316757, -10.158847753893692],
  [-5.30891590484703, -11.658847753893692],
  [-8.908916286316757, -6.758846228014786],
  [-7.80891590484703, -8.358848516833145],
  [-7.10891704925621, -4.358848516833145],
  [-9.30891590484703, -9.158847753893692],
  [-6.60891704925621, -4.858848516833145],
  [-4.008916667786483, -6.958846990954239],
  [-5.408916286316757, -2.7588481353634187],
  [5.89108295074379, -9.058849279772598],
  [6.89108295074379, -8.058849279772598],
  [2.69108409515297, -5.958846990954239],
  [-4.508916667786483, 9.641151483166855],
  [-3.80891590484703, 2.4411526275760345],
  [0.29108447662269654, -3.2588481353634187],
  [-2.008916667786483, -0.8588485168331452],
  [-2.1089170492562097, -1.458846990954239],
  [-4.408916286316757, 8.841152246106308],
  [0.19108409515296998, -0.8588485168331452],
  [-4.80891590484703, -0.25884813536341866],
  [-4.908916286316757, 4.341152246106308],
  [-4.10891704925621, 2.9411526275760345],
  [-0.30891590484703, -5.858848516833145],
  [3.0910837136832434, -5.258846228014786],
  [3.7910844766226965, -3.658847753893692],
  [-2.4089162863167566, 3.4411526275760345],
  [5.991083332213517, -11.358848516833145],
  [1.3910829507437903, -2.2588481353634187],
  [-5.7089155233773035, 0.9411526275760345],
  [1.19108409515297, -4.5588473724239655],
  [3.7910844766226965, -9.658847753893692],
  [3.69108409515297, -4.358848516833145],
  [-3.9089162863167566, 5.9411526275760345],
  [-2.7089155233773035, 4.4411526275760345],
  [-0.9089162863167566, 1.341152246106308],
  [-1.6089170492562097, 0.44115262757603446],
  [1.5910837136832434, -3.8588485168331452],
  [2.991083332213517, -6.758846228014786],
  [-2.508916667786483, 1.2411518646365813],
  [-4.408916286316757, 2.2411518646365813],
  [7.191082187804337, -7.358848516833145],
  [3.0910837136832434, -4.258848135363419],
  [-5.10891704925621, 1.6411514831668548],
  [-5.908916286316757, 7.4411526275760345],
  [6.691082187804337, -8.958846990954239],
  [2.3910829507437903, -3.958846990954239],
  [4.7910844766226965, -8.158847753893692],
  [5.7910844766226965, -5.158847753893692],
  [-5.60891704925621, 6.641151483166855],
  [-1.6089170492562097, -3.158847753893692],
  [-0.20891552337730346, -2.658847753893692],
  [5.491083332213517, -7.958846990954239],
  [-1.2089155233773035, 0.8411522461063079],
  [5.991083332213517, -10.558849279772598],
  [-5.908916286316757, 10.141151483166855],
  [-3.1089170492562097, 5.141151483166855],
  [-2.6089170492562097, -1.0588473724239655],
  [1.19108409515297, -0.958846990954239],
  [0.7910844766226965, -5.158847753893692],
  [-6.30891590484703, 9.241151864636581],
  [-1.4089162863167566, -2.5588473724239655],
  [-3.2089155233773035, -1.158847753893692],
  [4.19108409515297, -10.158847753893692],
  [-3.7089155233773035, -1.458846990954239],
  [-0.008916667786483146, -1.958846990954239],
  [0.3910829507437903, -0.1588477538936921],
  [6.591083713683243, -6.958846990954239],
  [4.69108409515297, -6.658847753893692],
  [4.2910844766226965, -7.258846228014786],
  [-3.30891590484703, 2.2411518646365813],
  [-2.7089155233773035, -1.658847753893692],
  [8.291084476622697, -7.458846990954239],
  [0.69108409515297, -4.158847753893692],
  [3.69108409515297, -7.158847753893692],
  [6.091083713683243, -6.458846990954239],
  [-4.508916667786483, 1.6411514831668548],
  [-2.6089170492562097, 1.9411526275760345],
  [2.8910829507437903, -3.5588473724239655],
  [-3.1089170492562097, 0.041153009045761024],
  [-6.80891590484703, 3.841152246106308],
  [-6.80891590484703, 7.141151483166855],
  [-2.80891590484703, 0.7411518646365813],
  [-2.2089155233773035, 2.341152246106308],
  [-5.908916286316757, 1.4411526275760345],
  [1.8910829507437903, -7.258846228014786],
  [5.19108409515297, -9.358848516833145],
  [0.49108333221351685, -5.758846228014786],
  [4.991083332213517, -5.358848516833145],
  [7.39108295074379, -6.558849279772598],
  [-4.2089155233773035, 4.041153009045761],
  [-1.9089162863167566, 3.1411514831668548],
  [1.0910837136832434, -5.858848516833145],
  [-2.4089162863167566, 3.9411526275760345],
  [3.3910829507437903, -8.258846228014786],
  [-6.2089155233773035, 5.041153009045761],
  [2.491083332213517, -2.2588481353634187],
  [-2.008916667786483, -0.1588477538936921],
  [-0.4089162863167566, 1.041153009045761],
  [3.3910829507437903, -6.358848516833145],
  [7.39108295074379, -8.658847753893692],
  [0.3910829507437903, -2.5588473724239655],
  [-3.30891590484703, -1.8588485168331452],
  [0.29108447662269654, -6.358848516833145],
  [6.39108295074379, -5.658847753893692],
  [-5.60891704925621, 2.4411526275760345],
  [1.8910829507437903, -4.458846990954239],
  [-1.9089162863167566, 1.1411514831668548],
  [4.991083332213517, -6.058849279772598],
  [-3.6089170492562097, 6.641151483166855],
  [-5.7089155233773035, 5.641151483166855],
  [-4.408916286316757, 3.541153009045761],
  [0.9910833322135169, -2.8588485168331452],
  [-5.508916667786483, 0.44115262757603446],
  [2.19108409515297, -6.558849279772598],
  [6.2910844766226965, -7.758846228014786],
  [-2.508916667786483, 2.841152246106308],
  [-5.008916667786483, 2.2411518646365813],
  [-1.1089170492562097, -1.2588481353634187],
  [-1.5089166677864831, 2.2411518646365813],
  [-1.1089170492562097, 1.841152246106308],
  [-5.60891704925621, 1.841152246106308],
  [-4.30891590484703, 4.741151864636581],
  [-3.7089155233773035, -0.25884813536341866],
  [4.2910844766226965, -5.558849279772598],
  [-4.7089155233773035, 11.441152627576034],
  [5.39108295074379, -6.758846228014786],
  [-1.2089155233773035, -4.258848135363419],
  [-5.2089155233773035, 7.541153009045761],
  [-4.508916667786483, -1.3588485168331452],
  [4.491083332213517, -4.658847753893692],
  [-2.2089155233773035, -3.2588481353634187],
  [5.2910844766226965, -8.658847753893692],
  [4.39108295074379, -3.958846990954239],
  [4.2910844766226965, -8.658847753893692],
  [1.4910833322135169, -6.458846990954239],
  [-6.508916667786483, 2.7411518646365813],
  [2.19108409515297, -3.2588481353634187],
  [-4.908916286316757, 3.6411514831668548],
  [-2.2089155233773035, 0.6411514831668548],
  [-5.30891590484703, 10.941152627576034],
  [-0.4089162863167566, -3.3588485168331452],
  [0.09108371368324342, 0.3411522461063079],
  [-4.80891590484703, 0.44115262757603446],
  [6.7910844766226965, -10.058849279772598],
  [-3.7089155233773035, 4.541153009045761],
  [2.5910837136832434, -8.358848516833145],
  [-5.30891590484703, -0.05884737242396554],
  [-1.5089166677864831, 1.4411526275760345],
  [-1.6089170492562097, -3.7588481353634187],
  [-1.5089166677864831, -0.1588477538936921],
  [-4.30891590484703, 6.541153009045761],
  [-3.2089155233773035, -0.5588473724239655],
  [-1.9089162863167566, -4.358848516833145],
  [-5.30891590484703, 8.741151864636581],
  [-3.30891590484703, 5.741151864636581],
  [3.3910829507437903, -3.158847753893692],
  [-3.6089170492562097, 0.9411526275760345],
  [-5.2089155233773035, 5.9411526275760345],
  [1.5910837136832434, -3.158847753893692],
  [-3.1089170492562097, 1.6411514831668548],
  [-4.60891704925621, 1.1411514831668548],
  [-1.30891590484703, -4.858848516833145],
  [-5.60891704925621, 4.041153009045761],
  [7.091083713683243, -9.458846990954239],
  [1.7910844766226965, -5.858848516833145],
  [4.591083713683243, -9.258846228014786],
  [-3.1089170492562097, 1.1411514831668548],
  [3.7910844766226965, -5.058849279772598],
  [1.2910844766226965, -7.258846228014786],
  [0.7910844766226965, -1.458846990954239],
  [-0.80891590484703, -5.358848516833145],
  [-3.7089155233773035, -0.958846990954239],
  [5.39108295074379, -10.158847753893692],
  [-0.008916667786483146, -3.958846990954239],
  [-2.9089162863167566, 2.541153009045761],
  [-5.408916286316757, 9.641151483166855],
  [-3.008916667786483, 3.2411518646365813],
  [-1.0089166677864831, 0.24115186463658134],
  [-6.7089155233773035, 8.141151483166855],
  [-4.30891590484703, 0.7411518646365813],
  [-0.6089170492562097, -4.158847753893692],
  [-3.508916667786483, 0.3411522461063079],
  [-2.4089162863167566, -2.158847753893692],
  [2.8910829507437903, -2.7588481353634187],
  [-1.5089166677864831, -0.8588485168331452],
  [2.69108409515297, -4.758846228014786],
  [-7.008916667786483, 4.9411526275760345],
  [2.5910837136832434, -7.358848516833145],
  [-4.60891704925621, 10.441152627576034],
  [4.7910844766226965, -10.058849279772598],
  [0.8910829507437903, -3.5588473724239655],
  [-4.30891590484703, -0.7588481353634187],
  [3.991083332213517, -7.858848516833145],
  [0.09108371368324342, -5.158847753893692],
  [-2.008916667786483, 1.7411518646365813],
  [-4.10891704925621, 0.3411522461063079],
  [-3.9089162863167566, 1.341152246106308],
  [-6.2089155233773035, 2.041153009045761],
  [2.19108409515297, -5.358848516833145],
  [-5.60891704925621, 3.4411526275760345],
  [-2.6089170492562097, -0.458846990954239],
  [-0.80891590484703, -2.7588481353634187],
  [-4.2089155233773035, -1.8588485168331452],
  [1.4910833322135169, -1.5588473724239655],
  [-5.2089155233773035, 2.9411526275760345],
  [-0.5089166677864831, 0.541153009045761],
  [-2.9089162863167566, -3.3588485168331452],
  [-0.4089162863167566, -1.3588485168331452],
  [6.091083713683243, -9.758846228014786],
  [-3.7089155233773035, 3.4411526275760345],
  [6.191082187804337, -8.458846990954239],
  [-4.908916286316757, -0.7588481353634187],
  [-4.30891590484703, -0.1588477538936921],
  [-3.80891590484703, -2.2588481353634187],
  [-7.008916667786483, 6.141151483166855],
  [2.0910837136832434, -7.958846990954239],
  [-4.7089155233773035, 2.7411518646365813],
  [-0.6089170492562097, -1.958846990954239],
  [4.991083332213517, -7.458846990954239],
  [-1.6089170492562097, -1.658847753893692],
  [3.0910837136832434, -8.958846990954239],
  [-0.9089162863167566, -0.458846990954239],
  [-5.2089155233773035, 5.041153009045761],
  [-3.80891590484703, 1.841152246106308],
  [-4.60891704925621, 5.241151864636581],
  [-3.80891590484703, 5.241151864636581],
  [-4.508916667786483, 5.841152246106308],
  [-3.008916667786483, 3.7411518646365813],
  [3.491083332213517, -5.658847753893692],
  [7.89108295074379, -6.958846990954239],
  [5.39108295074379, -10.958846990954239],
  [-5.908916286316757, 8.241151864636581],
  [-1.7089155233773035, 2.6411514831668548],
  [5.19108409515297, -4.658847753893692],
  [0.7910844766226965, -0.5588473724239655],
  [-0.30891590484703, -0.1588477538936921],
  [-3.1089170492562097, -2.3588485168331452],
  [-5.10891704925621, 1.041153009045761],
  [1.9910833322135169, -2.5588473724239655],
  [0.19108409515296998, -4.5588473724239655],
  [0.7910844766226965, -2.0588473724239655],
  [-2.008916667786483, -2.458846990954239],
  [-3.4089162863167566, 2.9411526275760345],
  [1.9910833322135169, -1.7588481353634187],
  [7.691082187804337, -7.958846990954239],
  [6.89108295074379, -6.158847753893692],
  [-1.2089155233773035, -2.0588473724239655],
  [-6.008916667786483, 2.9411526275760345],
  [-2.6089170492562097, -2.7588481353634187],
  [-3.4089162863167566, -2.8588485168331452],
  [-6.30891590484703, 3.541153009045761],
  [0.7910844766226965, -6.758846228014786],
  [0.29108447662269654, -1.458846990954239],
  [-3.2089155233773035, 4.541153009045761],
  [-4.30891590484703, 12.341152246106308],
  [1.4910833322135169, -5.158847753893692],
  [3.69108409515297, -8.958846990954239],
  [-4.908916286316757, 6.841152246106308],
  [4.091083713683243, -6.358848516833145],
  [-1.0089166677864831, -3.458846990954239],
  [-4.10891704925621, 7.9411526275760345],
  [4.69108409515297, -10.958846990954239],
  [5.19108409515297, -11.658847753893692],
  [6.49108523956215, -10.758846228014786],
  [-0.4089162863167566, -0.7588481353634187],
  [-5.7089155233773035, 4.641151483166855],
  [-0.5089166677864831, -4.758846228014786],
  [-4.7089155233773035, 8.041153009045761],
  [-2.30891590484703, -3.8588485168331452],
  [-6.408916286316757, 4.341152246106308],
  [5.69108409515297, -5.858848516833145],
  [-3.508916667786483, 3.9411526275760345],
  [3.19108409515297, -7.658847753893692],
  [-6.508916667786483, 5.641151483166855],
  [-4.10891704925621, 7.241151864636581],
  [5.89108295074379, -7.258846228014786],
  [-2.508916667786483, 0.24115186463658134],
  [-6.30891590484703, 6.4411526275760345],
  [-0.30891590484703, 1.7411518646365813],
  [-0.10891704925620971, 1.341152246106308],
  [4.591083713683243, -3.458846990954239],
  [8.191082187804337, -6.458846990954239],
  [5.7910844766226965, -4.5588473724239655],
  [7.691082187804337, -6.058849279772598],
  [-2.6089170492562097, 5.4411526275760345],
  [-4.008916667786483, 11.141151483166855],
  [-3.9089162863167566, 10.341152246106308],
  [-3.9089162863167566, 9.641151483166855],
  [3.0910837136832434, -2.0588473724239655],
  [5.39108295074379, -4.158847753893692],
  [4.991083332213517, -3.7588481353634187],
  [1.69108409515297, -0.6588477538936921],
  [-2.80891590484703, 6.041153009045761],
  [8.691082187804337, -6.858848516833145],
  [-3.7089155233773035, 8.941152627576034],
  [-3.9089162863167566, 11.941152627576034],
  [6.2910844766226965, -4.858848516833145],
  [6.691082187804337, -5.258846228014786],
  [-2.30891590484703, 5.041153009045761],
  [-3.008916667786483, 6.541153009045761],
  [-2.1089170492562097, 4.541153009045761],
  [4.19108409515297, -3.0588473724239655],
  [-3.6089170492562097, 8.241151864636581],
  [-0.6089170492562097, 2.041153009045761],
  [3.7910844766226965, -2.7588481353634187],
  [0.19108409515296998, 1.041153009045761],
  [2.3910829507437903, -1.3588485168331452],
  [1.0910837136832434, 0.041153009045761024],
  [-1.9089162863167566, 4.041153009045761],
  [0.7910844766226965, 0.3411522461063079],
  [-3.2089155233773035, 7.141151483166855],
  [-3.7089155233773035, 12.741151864636581],
  [9.191082187804337, -7.358848516833145],
  [-0.9089162863167566, 2.4411526275760345],
  [-1.1089170492562097, 2.841152246106308],
  [-1.4089162863167566, 3.2411518646365813],
  [0.49108333221351685, 0.7411518646365813],
  [7.191082187804337, -5.658847753893692],
  [-3.4089162863167566, 7.641151483166855],
  [2.69108409515297, -1.7588481353634187],
  [-1.6089170492562097, 3.6411514831668548],
  [1.3910829507437903, -0.3588485168331452],
  [1.9910833322135169, -0.958846990954239],
  [-3.30891590484703, 13.441152627576034],
  [3.491083332213517, -2.3588485168331452],
  [-3.1089170492562097, 14.041152055371445],
  [2.491083332213517, -9.058849279772598],
  [-6.80891590484703, 2.041153009045761],
  [-4.2089155233773035, -2.458846990954239],
  [-7.60891704925621, 5.9411526275760345],
  [-2.30891590484703, -4.658847753893692],
  [4.091083713683243, -10.958846990954239],
  [-3.6089170492562097, -3.158847753893692],
  [-3.6089170492562097, 13.641152436841171],
  [-4.60891704925621, 12.841152246106308],
  [1.9910833322135169, -8.558849279772598],
  [-4.80891590484703, -1.7588481353634187],
  [-7.10891704925621, 8.941152627576034],
  [-1.4089162863167566, 14.941152627576034],
  [-5.80891590484703, 11.341152246106308],
  [-7.60891704925621, 6.741151864636581],
  [-5.30891590484703, -0.958846990954239],
  [-7.30891590484703, 8.241151864636581],
  [-0.80891590484703, 15.141152436841171],
  [0.8910829507437903, -7.558849279772598],
  [4.39108295074379, -11.458846990954239],
  [-5.408916286316757, 11.841152246106308],
  [-0.10891704925620971, 15.241151864636581],
  [-7.508916667786483, 5.141151483166855],
  [0.3910829507437903, -7.058849279772598],
  [-7.10891704925621, 2.841152246106308],
  [-6.80891590484703, 9.541153009045761],
  [-6.10891704925621, 0.541153009045761],
  [-7.408916286316757, 4.341152246106308],
  [-5.7089155233773035, -0.25884813536341866],
  [3.7910844766226965, -10.458846990954239],
  [-0.80891590484703, -5.958846990954239],
  [-7.508916667786483, 7.541153009045761],
  [-7.30891590484703, 3.541153009045761],
  [-6.508916667786483, 10.241151864636581],
  [-6.10891704925621, 10.741151864636581],
  [-2.6089170492562097, 14.441152627576034],
  [4.69108409515297, -11.958846990954239],
  [-6.508916667786483, 1.2411518646365813],
  [3.3910829507437903, -9.958846990954239],
  [-5.008916667786483, 12.341152246106308],
  [-2.008916667786483, 14.741151864636581],
  [-1.5089166677864831, -5.358848516833145],
  [2.8910829507437903, -9.458846990954239],
  [-3.008916667786483, -3.958846990954239],
  [-0.20891552337730346, -6.558849279772598],
  [-4.10891704925621, 13.241151864636581],
  [1.4910833322135169, -8.058849279772598],
  [6.091083713683243, 11.741151864636581],
  [8.291084476622697, 7.641151483166855],
  [8.291084476622697, 4.641151483166855],
  [8.39108295074379, 7.041153009045761],
  [6.7910844766226965, 10.741151864636581],
  [4.39108295074379, 13.441152627576034],
  [2.0910837136832434, 14.841152246106308],
  [7.49108523956215, 2.4411526275760345],
  [8.091083713683243, 8.141151483166855],
  [5.89108295074379, 0.041153009045761024],
  [6.591083713683243, 0.9411526275760345],
  [6.39108295074379, 11.241151864636581],
  [0.5910837136832434, 15.241151864636581],
  [7.091083713683243, 10.241151864636581],
  [7.691082187804337, 9.241151864636581],
  [3.3910829507437903, 14.241151864636581],
  [7.39108295074379, 9.741151864636581],
  [7.89108295074379, 8.741151864636581],
  [1.3910829507437903, 15.141152436841171],
  [7.99108523956215, 3.541153009045761],
  [3.8910829507437903, 13.841152246106308],
  [8.291084476622697, 5.241151864636581],
  [4.091083713683243, -1.658847753893692],
  [2.7910844766226965, 14.541152055371445],
  [8.39108295074379, 6.4411526275760345],
  [6.99108523956215, 1.4411526275760345],
  [5.69108409515297, 12.141152436841171],
  [8.091083713683243, 4.141151483166855],
  [5.2910844766226965, 12.641152436841171],
  [8.39108295074379, 5.841152246106308],
  [4.991083332213517, -0.8588485168331452],
  [7.7910844766226965, 3.041153009045761],
  [4.89108295074379, 13.041152055371445],
  [7.2910844766226965, 1.9411526275760345],
  [6.2910844766226965, 0.541153009045761],
  [5.491083332213517, -0.458846990954239],
  [4.591083713683243, -1.2588481353634187],
  [-2.6089170492562097, -7.058849279772598],
  [-2.008916667786483, -6.358848516833145],
  [-3.9089162863167566, -9.258846228014786],
  [-4.60891704925621, -11.058849279772598],
  [-4.408916286316757, -10.558849279772598],
  [-4.80891590484703, -11.658847753893692],
  [-3.008916667786483, -7.758846228014786],
  [-4.908916286316757, -12.158847753893692],
  [-4.2089155233773035, -9.958846990954239],
  [-3.508916667786483, -8.558849279772598],
  [3.7910844766226965, 10.441152627576034],
  [3.491083332213517, 7.4411526275760345],
  [2.991083332213517, 13.641152436841171],
  [3.19108409515297, 13.141152436841171],
  [3.3910829507437903, 6.9411526275760345],
  [0.29108447662269654, 2.4411526275760345],
  [2.991083332213517, 5.9411526275760345],
  [3.19108409515297, 6.4411526275760345],
  [3.69108409515297, 8.041153009045761],
  [2.19108409515297, 4.4411526275760345],
  [3.7910844766226965, 8.641151483166855],
  [0.7910844766226965, 2.841152246106308],
  [2.7910844766226965, 5.4411526275760345],
  [1.4910833322135169, 3.541153009045761],
  [3.5910837136832434, 12.141152436841171],
  [1.0910837136832434, 3.1411514831668548],
  [2.491083332213517, 4.9411526275760345],
  [3.7910844766226965, 9.241151864636581],
  [3.69108409515297, 11.541152055371445],
  [3.8910829507437903, 9.841152246106308],
  [3.7910844766226965, 10.941152627576034],
  [2.5910837136832434, 14.041152055371445],
  [1.8910829507437903, 4.041153009045761],
  [3.3910829507437903, 12.641152436841171],
  [2.19108409515297, 14.441152627576034],
  [-0.10891704925620971, 13.641152436841171],
  [1.2910844766226965, 11.641152436841171],
  [-2.9089162863167566, 11.641152436841171],
  [-1.0089166677864831, 12.541152055371445],
  [-1.0089166677864831, 13.241151864636581],
  [-1.6089170492562097, 13.941152627576034],
  [0.9910833322135169, 13.241151864636581],
  [0.49108333221351685, 14.441152627576034],
  [-0.20891552337730346, 14.441152627576034],
  [-1.0089166677864831, 14.341152246106308],
  [-1.6089170492562097, 13.141152436841171],
  [2.19108409515297, 13.341152246106308],
  [-0.008916667786483146, 13.041152055371445],
  [1.9910833322135169, 11.341152246106308],
  [-1.2089155233773035, 12.041152055371445],
  [-1.5089166677864831, 11.541152055371445],
  [1.4910833322135169, 12.941152627576034],
  [-2.1089170492562097, 12.041152055371445],
  [0.49108333221351685, 12.041152055371445],
  [1.9910833322135169, 12.641152436841171],
  [-0.008916667786483146, 12.341152246106308],
  [2.69108409515297, 12.541152055371445],
  [1.0910837136832434, 14.141152436841171],
  [-0.80891590484703, 11.641152436841171],
  [-2.2089155233773035, 11.341152246106308],
  [-2.4089162863167566, 12.741151864636581],
  [2.8910829507437903, 11.041153009045761],
  [-2.30891590484703, 13.441152627576034],
  [1.4910833322135169, 12.241151864636581],
  [0.5910837136832434, 11.641152436841171],
  [0.49108333221351685, 13.641152436841171],
  [2.0910837136832434, 11.941152627576034],
  [-0.5089166677864831, 12.141152436841171],
  [2.7910844766226965, 11.741151864636581],
  [-0.5089166677864831, 12.741151864636581],
  [-1.6089170492562097, 12.541152055371445],
  [1.69108409515297, 13.841152246106308],
  [0.9910833322135169, 12.441152627576034],
  [-0.10891704925620971, 11.641152436841171],
  [-3.1089170492562097, 11.041153009045761],
  [0.49108333221351685, 12.841152246106308],
  [-0.80891590484703, 13.741151864636581],
  [-2.9089162863167566, 12.341152246106308],
  [-7.508916667786483, -4.0588473724239655],
  [-8.908916286316757, -5.958846990954239],
  [-5.7089155233773035, -2.3588485168331452],
  [-6.908916286316757, -3.458846990954239],
  [-6.408916286316757, -2.8588485168331452],
  [-9.30891590484703, -6.558849279772598],
  [-8.008916667786483, -4.658847753893692],
  [-8.408916286316757, -5.258846228014786],
  [-9.708915523377303, -7.158847753893692],
  [-10.108916095581893, -7.658847753893692],
  [-11.008916667786483, -8.558849279772598],
  [-10.608916095581893, -8.158847753893692],
  [-2.2089155233773035, 10.741151864636581],
  [2.19108409515297, 10.741151864636581],
  [-3.008916667786483, 10.441152627576034],
  [-0.9089162863167566, 11.141151483166855],
  [0.29108447662269654, 11.141151483166855],
  [1.4910833322135169, 10.941152627576034],
  [2.991083332213517, 10.441152627576034],
  [-0.30891590484703, 11.141151483166855],
  [-1.5089166677864831, 10.941152627576034],
  [0.8910829507437903, 11.141151483166855],
  [6.591083713683243, -11.458846990954239],
  [7.99108523956215, -8.758846228014786],
  [8.39108295074379, -8.158847753893692],
  [6.191082187804337, -11.858848516833145],
  [6.89108295074379, -10.958846990954239],
  [7.191082187804337, -10.458846990954239],
  [7.691082187804337, -9.258846228014786],
  [7.49108523956215, -9.858848516833145],
  [4.991083332213517, -12.458846990954239],
  [5.591083713683243, -12.258846228014786],
  [8.791084476622697, -7.758846228014786],
];
